(function ($) {

    $(document).ready(function () {

            // If Marketo form exists
            if (typeof (MktoForms2) !== 'undefined') {

                // When Marketo is Rendered:
                MktoForms2.whenRendered(function (form) {

                    // Restyle MktoForm:
                    destyleMktoForm(form);

                // If Marketo FakeForm exists, hide native form:
                if ($('.mktoFakeForm').length) {
                    $('.mktoForm').hide();
                 } else {
                    if($('form.mktoForm').hasClass('select2_disable')){

                    }else{
                        // Init select2 dropdown plugin:
                         $('.mktoForm select.mktoField:not([name="typeofInquiry"])').select2({
                            matcher: matchStart
                             });
                                    $('.mktoForm select.mktoField[name="typeofInquiry"]').select2({
                                       minimumResultsForSearch: Infinity
                                        });
                                       }
                                   }

                });


                // When Marketo is Ready:
                MktoForms2.whenReady(function (form) {

                    var form_id = form.getId();


                    $('.mktoForm .mktoCheckboxList').each(function () {
                        $(this).parent('.mktoFieldWrap').addClass('mktoCheckboxListWrap');
                        if ($(this).find('input[type="checkbox"]:checked').length) {
                            $(this).closest('.mktoCheckboxListWrap').find('.mktoLabel').addClass('checked');
                        }

                        $('.mktoCheckboxListWrap input[type="checkbox"]').on('change', function (e) {
                            if ($(this)[0].checked === true) {
                                $(this).closest('.mktoFieldWrap').find('.mktoLabel').addClass('checked');
                            } else {
                                $(this).closest('.mktoFieldWrap').find('.mktoLabel').removeClass('checked');
                            }
                        });
                    });


                    $('.banking_information_checkboxes input[type="checkbox"]').on('change', function (e) {
                        if (this.checked) {
                            $(this).attr('checked', true).prop('checked', true);
                            $('.banking_information_checkboxes input[type="checkbox"]').not(this).attr('checked', false).prop('checked', false);
                        } else {
                            $(this).attr('checked', true).prop('checked', true);
                        }
                    });


                    // Quick feature for BlockChain landing form
                    if (form_id == '1383') {
                        $('#mktoForm_1383').find('.mktoCheckboxList').css('display', 'flex').prev().prev().remove();
                        var text = $('#mktoForm_1383').find('.mktoCheckboxList').attr('title');
                        $('#mktoForm_1383').find('.mktoCheckboxList').append("<span>* " + text + "</span>");
                    }


                    if (form_id == '1147' || form_id == '1289' || form_id == '1456' || form_id == '1477') {


                        // Show/hide State select on choose USA in Country select
                        var CityStates = [
                            ['Country', 'State'],
                            ['cPFLegalCountry', 'cPFLegalState'],
                            ['_Country', '_State'],
                            ['_cPFLegalCountry', 'cPFLegalState'],
                            ['sPFLegalCountry', 'sPFLegalState'],
                            ['sPFBankCountry', 'bankState'],
                            ['rPLegalCountry', 'rPLegalState']
                        ];
                        CityStates.forEach(function (item) {
                            $('span.' + item[1]).hide().next('br').hide();
                            $('.mktoFakeForm select[name="' + item[0] + '"]').on('change', function (e) {
                                if ($(this).val() == 'United States') {
                                    $('span.' + item[1]).fadeIn('slow').next('br').show();
                                } else {
                                    $('span.' + item[1]).fadeOut('slow').next('br').hide();
                                    $('span.' + item[1]).find('select option').eq(0).prop('selected', true).trigger('change');
                                }
                            });
                        });


                        // Notification of possible data loss when leaving the page
                        var data_needs_saving;
                        window.onbeforeunload = function () {
                            if (data_needs_saving != "false") {
                                return "Do you really want to leave our brilliant application?";
                            } else {
                                return;
                            }
                        };

                        // PACT SAFE Load script //
                        /*(function (w, d, s, c, n, a, b) {
                         w['PactSafeObject'] = n;
                         w[n] = w[n] || function () {
                         (w[n].q = w[n].q || []).push(arguments)
                         }, w[n].t = 1 * new Date();
                         a = d.createElement(s), b = d.getElementsByTagName(s)[0];
                         a.async = 1;
                         a.src = c;
                         b.parentNode.insertBefore(a, b)
                         })(window, document, 'script', '//ps-vault.s3.amazonaws.com/ps.min.js', '_ps');*/

                        (function (w, d, s, c, n, a, b) {
                            w['PactSafeObject'] = n;
                            w[n] = w[n] || function () {
                                (w[n].q = w[n].q || []).push(arguments)
                            }, w[n].on = function () {
                                (w[n].e = w[n].e || []).push(arguments)
                            }, w[n].once = function () {
                                (w[n].eo = w[n].eo || []).push(arguments)
                            }, w[n].off = function () {
                                (w[n].o = w[n].o || []).push(arguments)
                            }, w[n].t = 1 * new Date();
                            a = d.createElement(s), b = d.getElementsByTagName(s)[0];
                            a.async = 1;
                            a.src = c;
                            b.parentNode.insertBefore(a, b)
                        })(window, document, 'script', '//vault.pactsafe.io/ps.min.js', '_ps');


                        // initiate PactSafe with your SITE ACCESS ID found here: http://beta.pactsafe.com/settings/account
                        _ps('create', '3e27d21a-eed0-4c21-8a5d-ad194db8c423', {dynamic: true, disable_sending: true});


                        var what_to_render = {},
                            custom_data = {},
                            signer_id;


                        // Update data on changing fields:

                        $('.mktoFakeForm input[name="FirstName"]').on('change', function (e) {
                            what_to_render.first_name = $(this).val();
                            custom_data.first_name = $(this).val();
                        });
                        $('.mktoFakeForm input[name="LastName"]').on('change', function (e) {
                            what_to_render.last_name = $(this).val();
                            custom_data.last_name = $(this).val();
                        });
                        $('.mktoFakeForm input[name="Email"]').on('change', function (e) {
                            what_to_render.email = $(this).val();
                            signer_id = $(this).val();
                        });
                        $('.mktoFakeForm input[name="Phone"]').on('change', function (e) {
                            what_to_render.phone = $(this).val();
                        });
                        $('.mktoFakeForm input[name="Company"]').on('change', function (e) {
                            what_to_render.company_name = $(this).val();
                            custom_data.company_name = $(this).val();
                        });
                        $('.mktoFakeForm input[name="Title"]').on('change', function (e) {
                            what_to_render.title = $(this).val();
                            custom_data.title = $(this).val();
                        });

                    }


                    // Functions for CommPay form only:
                    if (form_id == '1289') {

                        // Set the required variables:
                        var agreement_key = 'commpay-online',
                            FirstName, LastName;

                        $('.mktoFakeForm .page-1 input[name="Company"]').on('change keyup paste', function (e) {
                            $('.mktoFakeForm .page-3 input[name="Company"], .mktoFakeForm .page-6 input[name="Company"]').val($(this).val());
                        });


                        $('.mktoFakeForm input[name="FirstName"]').on('change keyup paste', function (e) {
                            FirstName = $(this).val();
                            prefillFullName();
                        });
                        $('.mktoFakeForm input[name="LastName"]').on('change keyup paste', function (e) {
                            LastName = $(this).val();
                            prefillFullName();
                        });

                        function prefillFullName() {
                            $('.mktoFakeForm').find('#balancingContactName, #fundingContactName, #contractContactName').val(FirstName + ' ' + LastName).trigger("change");
                        }

                        $('.mktoFakeForm input[name="Email"]').on('change keyup paste', function (e) {
                            $('.mktoFakeForm').find('#balancingContactEmail, #fundingContactEmail, #contractContactEmail').val($(this).val()).trigger("change");
                        });
                        $('.mktoFakeForm input[name="Title"]').on('change keyup paste', function (e) {
                            $('.mktoFakeForm').find('#balancingContactTitle, #fundingContactTitle, #contractContactTitle').val($(this).val()).trigger("change");
                        });

                    }

                    function validationError(field, message) {
                        message = message || "This field is required.";
                        $(field).parent('.bootstrap-select').addClass('invalid');
                        $(field).addClass('invalid').parent().append('<div class="mktoError"><div class="mktoErrorArrowWrap"><div class="mktoErrorArrow"></div></div><div class="mktoErrorMsg">' + message + '</div></div>');
                    }

                    function validateMktoPage(page) {

                        var haveErrors = false;

                        if (!page.find('.switchable_section:hidden').length) {

                            page.find('input, select, textarea').each(function () {


                                $(this).parent().find('.mktoError').remove();
                                $(this).parent().find('.invalid').removeClass('invalid');
                                $(this).parent('.bootstrap-select').removeClass('invalid');

                                if ($(this).attr('type') !== 'submit') {

                                    if ($(this).attr('data-required') === "true") {

                                        if ($(this).attr('type') === 'email') {
                                            var value = $(this).val();
                                            if (value.length !== 0) {
                                                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                                if (!re.test(String(value).toLowerCase())) {
                                                    haveErrors = true;
                                                    validationError($(this), 'Must be valid email.<br>example@yourdomain.com');
                                                }
                                            } else {
                                                haveErrors = true;
                                                validationError($(this));
                                            }
                                        }

                                        if ($(this).attr('type') === 'text' || $(this).prop('tagName') === 'TEXTAREA') {

                                            var value = $(this).val();

                                            if (value.length === 0) {
                                                haveErrors = true;
                                                validationError($(this));
                                            }

                                        }

                                        if ($(this).attr('type') === "tel") {
                                            var value = $(this).val();
                                            if (value.length !== 0) {
                                                //var re = /^\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})$/;
                                                var re = /^[ ()+0-9-]+$/;
                                                if (!re.test(String(value).toLowerCase())) {
                                                    haveErrors = true;
                                                    validationError($(this), 'Must be a phone number');
                                                }
                                            } else {
                                                haveErrors = true;
                                                validationError($(this));
                                            }
                                        }


                                        if ($(this).attr('type') === 'radio') {
                                            var radioName = $(this).attr('name');
                                            if ($('input[name=' + radioName + ']:checked').length) {
                                                // good
                                            } else {
                                                haveErrors = true;
                                                validationError($(this));
                                            }
                                        }

                                        if ($(this).attr('type') === 'checkbox' && $(this).attr('data-switchable') !== "true") {
                                            if ($(this)[0].checked === false) {
                                                haveErrors = true;
                                                validationError($(this));
                                            }
                                        }

                                        if ($(this).prop('tagName') === "SELECT") {
                                            var value = $(this).val();
                                            if (value === "") {
                                                haveErrors = true;
                                                validationError($(this));
                                            }
                                        }

                                    } else if ($(this).attr('data-required') === "false") {

                                        if ($(this).attr('type') === "tel") {
                                            var value = $(this).val();
                                            if (value.length !== 0) {
                                                var re = /^[ ()+0-9-]+$/;
                                                if (!re.test(String(value).toLowerCase())) {
                                                    haveErrors = true;
                                                    validationError($(this), 'Must be a phone number');
                                                }
                                            }
                                        }

                                        if ($(this).attr('type') === "email") {
                                            var value = $(this).val();
                                            if (value.length !== 0) {
                                                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                                if (!re.test(String(value).toLowerCase())) {
                                                    haveErrors = true;
                                                    validationError($(this), 'Must be valid email.<br>example@yourdomain.com');
                                                }
                                            }
                                        }

                                    }
                                }

                            });
                        }
                        //reCaptha



                        if (page.find('[id^=pactsafe_checkbox-]').length) {
                            if (typeof agreement_key != 'undefined') {
                                if (_ps.getByKey(agreement_key).allChecked()) {
                                    $('#pactsafe_checkbox-' + agreement_key).removeClass('invalid');
                                } else {
                                    //alert("You must agree to the " + agreement_key + " terms to continue.");
                                    alert("Please agree to the terms to continue.");
                                    $('#pactsafe_checkbox-' + agreement_key).addClass('invalid');
                                    haveErrors = true;
                                }
                            }
                            if (typeof agreement_key2 != 'undefined') {
                                if (_ps.getByKey(agreement_key2).allChecked()) {
                                    $('#pactsafe_checkbox-' + agreement_key2).removeClass('invalid');
                                } else {
                                    //alert("You must agree to the " + agreement_key2 + " terms to continue.");
                                    alert("Please agree to the terms to continue.");
                                    $('#pactsafe_checkbox-' + agreement_key2).addClass('invalid');
                                    haveErrors = true;
                                }
                            }
                        }


                        if (haveErrors) {
                            return false;
                        }

                        return true;

                    }


                    $('.backOfficeSystem-checbox input').change(function (e) {
                        $('.backOfficeSystem-checbox input').attr('checked', false).prop('checked', false);
                        $(this).attr('checked', true).prop('checked', true);
                        if ($(this).attr('id') == 'fake_Systems2') {
                            $('.backOfficeSystem-wrap').slideUp();
                            $('.backOfficeSystem-wrap').find('input').attr({
                                'data-required': 'false',
                                'aria-required': 'false'
                            })
                            $('#backOfficeSystem').val('None');

                        } else {
                            $('.backOfficeSystem-wrap').find('input').attr({
                                'data-required': 'true',
                                'aria-required': 'true'
                            })
                        }
                    });

                    var compleateStepForm1147 = false;
                    // Functions for SurePay form only:
                    if (form_id == '1147') {

                        setTimeout(function () {
                            $('.sPFAgencyID #mktoCheckbox_8746_4').click()
                        }, 1000);

                        var last = false;
                        // Set the required variables:
                        var //agreement_key2 = 'sure-pay-cca',
                            agreement_key = 'sure-pay-online',
                            FirstName, LastName;

                        $('.mktoFakeForm input[name="FirstName"]').on('change keyup paste', function (e) {
                            FirstName = $(this).val();
                            prefillFullName()
                        });
                        $('.mktoFakeForm input[name="LastName"]').on('change keyup paste', function (e) {
                            LastName = $(this).val();
                            prefillFullName()
                        });

                        function prefillFullName() {
                            $('.mktoFakeForm input[name="sPFFullName"]').val(FirstName + ' ' + LastName).trigger("change");
                        }


                        $('.mktoFakeForm input[name="Email"]').on('change keyup paste', function (e) {
                            $('.mktoFakeForm input[name="sPFEmailAddress"],.mktoFakeForm input[name="sPFStatementEmailAddress"]').val($(this).val()).trigger("change");
                        });


                        $('.mktoFakeForm .page-1 input[name="Company"]').on('change keyup paste', function (e) {
                            $('.mktoFakeForm .page-2 input[name="Company"]').val($(this).val());
                        });

                        what_to_render.sure_pay_fee = '7%';

                        $('#mktoForm_1147 #spf_surepayfee').val('7');
                        $('.mktoFakeForm select[name="sPFCurrencyText"]').on('change', function (e) {
                            if ($(this).val() == 'USD') {
                                $('.SurePayFee').text('7');
                                what_to_render.sure_pay_fee = '7%';
                                $('#mktoForm_1147 #spf_surepayfee').val('7');
                            } else {
                                $('.SurePayFee').text('8');
                                what_to_render.sure_pay_fee = '8%';
                                $('#mktoForm_1147 #spf_surepayfee').val('8');
                            }
                        });


                        function clearSubSection(section) {


                            $(section).find('.invalid').removeClass('invalid');
                            $(section).find('.mktoError').remove();

                            $(section).find('input, select, textarea').each(function () {

                                if ($(this).prop('tagName') === "INPUT" || $(this).prop('tagName') === "TEXTAREA") {
                                    $(this).val('');
                                    $(this).prop('checked', false);
                                    _hidden.find('#' + $(this).attr('name')).val('').prop('checked', false);
                                }

                                if ($(this).prop('tagName') === "SELECT") {
                                    $(this).find('option').eq(0).prop('selected', true).trigger('change');
                                    _hidden.find('#' + $(this).attr('name')).find('option').eq(0).prop('selected', true).trigger('change');
                                    //$(this).next('.select2').find('.select2-selection__rendered').text($(this).val());
                                }

                            });
                        }

                        var _hidden = $(form.getFormElem());
                        $('.sPFAgencyID input[type="checkbox"]').on('change', function (e) {
                            var section = $(this).parent().attr('data-switch');
                            if (this.checked) {
                                if ($(this).parent().attr('data-switch-reverse')) {
                                    $('.' + section).slideUp(function () {
                                        clearSubSection('.' + section);
                                    });
                                } else {
                                    $('.' + section).slideDown();

                                    $('.' + section).find('input').attr({
                                        'data-required': 'true',
                                        'aria-required': 'true'
                                    })

                                }
                            } else {
                                if ($(this).parent().attr('data-switch-reverse')) {
                                    $('.' + section).slideDown();
                                } else {
                                    $('.' + section).slideUp(function () {
                                        clearSubSection('.' + section);
                                        $('.' + section).find('input').attr({
                                            'data-required': 'false',
                                            'aria-required': 'false'
                                        })
                                    });
                                }
                            }

                            if ($(this).attr('id') === 'mktoCheckbox_8746_4') {
                                $('.wrap_IATA').slideUp();
                                $('.wrap_ARC').slideUp();
                                $('.wrap_TIDS').slideUp();
                                $('.wrap_otherIDInformation').slideUp();

                                $('.wrap_otherIDInformation').find('input').attr({
                                    'data-required': 'false',
                                    'aria-required': 'false'
                                });
                                $('.wrap_TIDS').find('input').attr({
                                    'data-required': 'false',
                                    'aria-required': 'false'
                                });
                                $('.wrap_ARC').find('input').attr({
                                    'data-required': 'false',
                                    'aria-required': 'false'
                                });
                                $('.wrap_IATA').find('input').attr({
                                    'data-required': 'false',
                                    'aria-required': 'false'
                                });

                                if ($(this).is(':checked')) {
                                    $('.sPFAgencyID').find('input:not(#mktoCheckbox_8746_4)').each(function () {
                                        $(this).attr('checked', false).prop('checked', false);
                                        _hidden.find('#' + $(this).attr('id')).attr('checked', false).prop('checked', false);
                                    })
                                    _hidden.find('#' + $(this).attr('id')).attr('checked', true).prop('checked', true);
                                } else {
                                    $(this).attr('checked', true).prop('checked', true);
                                }
                            } else {
                                _hidden.find('#mktoCheckbox_8746_4').attr('checked', false).prop('checked', false);
                                if ($('.sPFAgencyID').find('input:not(#mktoCheckbox_8746_4):checked').length >= 1) {
                                    $('input#mktoCheckbox_8746_4').attr('checked', false).prop('checked', false);
                                } else {
                                    $('input#mktoCheckbox_8746_4').attr('checked', true).prop('checked', true);
                                }
                                _hidden.find('#' + $(this).attr('id')).click();
                            }

                            if (_hidden.find('#mktoCheckbox_8746_4').prop('checked') == true || _hidden.find('#mktoCheckbox_8746_3').prop('checked') == true && $('.sPFAgencyID input:checked').length == 1) {
                                console.log('last');
                                compleateStepForm1147 = 5;
                                var curr_page = $(this).closest('.page');
                                $('.section-form #step2').on('click', function (e) {
                                    if (validateMktoPage(curr_page)) {
                                        $('.pages').trigger('to.owl.carousel', [5, 500, true]);

                                        var fd = _hidden.serializeArray();
                                        fd.push({name: 'formVid', value: '1147'});
                                        $.ajax({
                                            type: "POST",
                                            url: "https://app-ab26.marketo.com/index.php/leadCapture/save2",
                                            data: fd,
                                            success: function (resp) {
                                                console.log(resp);
                                            }
                                        });

                                        setTimeout(function () {
                                            $('#sPFCurrencyText').select2('close');
                                        }, 500);
                                    }
                                });

                            } else {
                                console.log('next');
                                compleateStepForm1147 = false;
                                var curr_page = $(this).closest('.page');
                                $('.section-form #step2').unbind("click");
                                $('.section-form  #step2').on('click', function (e) {
                                    if (validateMktoPage(curr_page)) {
                                        $('.pages').trigger('next.owl.carousel');
                                        $("html, body").animate({
                                            scrollTop: (($('.section-form').offset().top) - 186)
                                        }, 1000);
                                    }
                                });
                            }

                        });
                    }

                    var compleateStepForm1477 = false;
                    // Functions for RecoverPro form only:
                    if (form_id == '1477') {
                        setTimeout(function () {
                            $('.sPFAgencyID #mktoCheckbox_8522_4').click()
                        }, 1000);
                        // Set the required variables:
                        var agreement_key2 = 'sure-pay-cca',
                            agreement_key = 'sure-pay-online',
                            FirstName, LastName;

                        $('.mktoFakeForm input[name="FirstName"]').on('change keyup paste', function (e) {
                            FirstName = $(this).val();
                            prefillFullName()
                        });
                        $('.mktoFakeForm input[name="LastName"]').on('change keyup paste', function (e) {
                            LastName = $(this).val();
                            prefillFullName()
                        });

                        function prefillFullName() {
                            $('.mktoFakeForm input[name="rPFullName"]').val(FirstName + ' ' + LastName).trigger("change");
                        }


                        $('.mktoFakeForm input[name="Email"]').on('change keyup paste', function (e) {
                            $('.mktoFakeForm input[name="rPEmail"],.mktoFakeForm input[name="rPStatementEmail"]').val($(this).val()).trigger("change");
                        });


                        $('.mktoFakeForm .page-1 input[name="Company"]').on('change keyup paste', function (e) {
                            $('.mktoFakeForm .page-2 input[name="Company"]').val($(this).val());
                        });


                        $('.mktoFakeForm select[name="rPCurrency"]').on('change', function (e) {
                            var existingSurePayCustomer = $('#mktoForm_1477 input[name="existingSurePayCustomer"]:checked').val();

                            if (existingSurePayCustomer == 'No') {
                                if ($(this).val() == 'USD') {
                                    $('.SurePayFee').text('6');
                                    what_to_render.sure_pay_fee = '6%';
                                    $('#mktoForm_1477 #rFSurePayFeewithRP').val('6%');
                                } else {
                                    $('.SurePayFee').text('7');
                                    what_to_render.sure_pay_fee = '7%';
                                    $('#mktoForm_1477 #rFSurePayFeewithRP').val('7%');
                                }
                            }

                        });


                        $('#mktoForm_1477 input[name="existingSurePayCustomer"]').change(function () {
                            var existingSurePayCustomer = $('#mktoForm_1477 input[name="existingSurePayCustomer"]:checked').val();

                            //console.log(existingSurePayCustomer);

                            if (existingSurePayCustomer == 'Yes') {
                                what_to_render.sure_pay_fee = 'Existing customer fee';
                                $('#mktoForm_1477 #rFSurePayFeewithRP').val('Existing customer fee');

                                $('.page-3 .banking_information_checkboxes').show();
                                $('.page-3 .banking_information_section').hide();

                                $('.page-4 .not-customer').hide();
                                $('.page-4 .customer').show();

                                //$('#mktoForm_1477 #useExistingBankInfo').attr('checked', true).prop('checked', true);
                            } else {
                                what_to_render.sure_pay_fee = '6%';
                                $('#mktoForm_1477 #rFSurePayFeewithRP').val('6%');

                                $('.page-3 .banking_information_checkboxes').hide();
                                $('.page-3 .banking_information_section').show();

                                $('.page-4 .customer').hide();
                                $('.page-4 .not-customer').show();

                                //$('#mktoForm_1477 #useExistingBankInfo').attr('checked', false).prop('checked', false);
                            }

                        });

                        what_to_render.recover_pro_fee = '$1.60';

                        var _hidden = $(form.getFormElem());

                        function clearSubSection(section) {


                            $(section).find('.invalid').removeClass('invalid');
                            $(section).find('.mktoError').remove();

                            $(section).find('input, select, textarea').each(function () {

                                if ($(this).prop('tagName') === "INPUT" || $(this).prop('tagName') === "TEXTAREA") {
                                    $(this).val('');
                                    $(this).prop('checked', false);
                                    _hidden.find('#' + $(this).attr('name')).val('').prop('checked', false);
                                }

                                if ($(this).prop('tagName') === "SELECT") {
                                    $(this).find('option').eq(0).prop('selected', true).trigger('change');
                                    _hidden.find('#' + $(this).attr('name')).find('option').eq(0).prop('selected', true).trigger('change');
                                    //$(this).next('.select2').find('.select2-selection__rendered').text($(this).val());
                                }

                            });
                        }

                        $('.sPFAgencyID input').change(function (e) {
                            var section = $(this).parent().attr('data-switch');
                            if (this.checked) {
                                if ($(this).parent().attr('data-switch-reverse')) {
                                    $('.' + section).slideUp(function () {
                                        clearSubSection('.' + section);
                                    });
                                } else {
                                    $('.' + section).slideDown();

                                    $('.' + section).find('input').attr({
                                        'data-required': 'true',
                                        'aria-required': 'true'
                                    })

                                }
                            } else {
                                if ($(this).parent().attr('data-switch-reverse')) {
                                    $('.' + section).slideDown();
                                } else {
                                    $('.' + section).slideUp(function () {
                                        clearSubSection('.' + section);
                                        $('.' + section).find('input').attr({
                                            'data-required': 'false',
                                            'aria-required': 'false'
                                        })
                                    });
                                }
                            }

                            if ($(this).attr('id') === 'mktoCheckbox_8522_4') {
                                $('.wrap_IATA').slideUp();
                                $('.wrap_ARC').slideUp();
                                $('.wrap_TIDS').slideUp();
                                $('.wrap_otherIDInformation').slideUp();
                                $('.wrap_otherIDInformation').find('input').attr({
                                    'data-required': 'false',
                                    'aria-required': 'false'
                                });
                                $('.wrap_TIDS').find('input').attr({
                                    'data-required': 'false',
                                    'aria-required': 'false'
                                });
                                $('.wrap_ARC').find('input').attr({
                                    'data-required': 'false',
                                    'aria-required': 'false'
                                });
                                $('.wrap_IATA').find('input').attr({
                                    'data-required': 'false',
                                    'aria-required': 'false'
                                });
                                if ($(this).is(':checked')) {
                                    $('.sPFAgencyID').find('input:not(#mktoCheckbox_8522_4)').each(function () {
                                        $(this).attr('checked', false).prop('checked', false);
                                        _hidden.find('#' + $(this).attr('id')).attr('checked', false).prop('checked', false);
                                    })
                                    _hidden.find('#' + $(this).attr('id')).attr('checked', true).prop('checked', true);
                                } else {
                                    $(this).attr('checked', true).prop('checked', true);
                                }
                            } else {
                                _hidden.find('#mktoCheckbox_8522_4').attr('checked', false).prop('checked', false);
                                if ($('.sPFAgencyID').find('input:not(#mktoCheckbox_8522_4):checked').length >= 1) {
                                    $('input#mktoCheckbox_8522_4').attr('checked', false).prop('checked', false);
                                } else {
                                    $('input#mktoCheckbox_8522_4').attr('checked', true).prop('checked', true);
                                }
                                _hidden.find('#' + $(this).attr('id')).click();
                            }

                            if (_hidden.find('#mktoCheckbox_8522_4').prop('checked') == true || _hidden.find('#mktoCheckbox_8522_3').prop('checked') == true && $('.sPFAgencyID input:checked').length == 1) {
                                console.log('last');
                                compleateStepForm1477 = 5;
                                var curr_page = $(this).closest('.page');
                                $('.section-form #step2').on('click', function (e) {
                                    if (validateMktoPage(curr_page)) {

                                        var fd = _hidden.serializeArray();
                                        fd.push({name: 'formVid', value: '1477'});
                                        $.ajax({
                                            type: "POST",
                                            url: "https://app-ab26.marketo.com/index.php/leadCapture/save2",
                                            data: fd,
                                            success: function (resp) {
                                                console.log(resp);
                                            }
                                        });
                                        $('.pages').trigger('to.owl.carousel', [5, 500, true]);
                                    }
                                });

                            } else {
                                console.log('next');
                                compleateStepForm1477 = false;
                                var curr_page = $(this).closest('.page');
                                $('.section-form #step2').unbind("click");
                                $('.section-form  #step2').on('click', function (e) {
                                    if (validateMktoPage(curr_page)) {
                                        if (_hidden.find('#gDSUsed').val() == 'None' || _hidden.find('#gDSUsed').val() == 'Other-NotListed') {
                                            compleateStepForm1477 = 5;
                                            var fd = _hidden.serializeArray();
                                            fd.push({name: 'formVid', value: '1477'});
                                            $.ajax({
                                                type: "POST",
                                                url: "https://app-ab26.marketo.com/index.php/leadCapture/save2",
                                                data: fd,
                                                success: function (resp) {
                                                    console.log(resp);
                                                }
                                            });
                                            $('.pages').trigger('to.owl.carousel', [5, 500, true]);

                                            $("html, body").animate({
                                                scrollTop: (($('.section-form').offset().top) - 186)
                                            }, 1000);
                                        } else {
                                            $('.pages').trigger('next.owl.carousel');
                                            $("html, body").animate({
                                                scrollTop: (($('.section-form').offset().top) - 186)
                                            }, 1000);
                                        }
                                    }
                                });
                            }


                        });


                    }


                    // Functions for GroupPay form only:
                    if (form_id == '1456') {
                        // Set the required variables:
                        var agreement_key = $('.mktoFakeForm').data('agreement_key');

                        //date-month name-year
                        var m_names = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"),
                            d = new Date(), curr_date = d.getDate(), curr_month = d.getMonth(), curr_year = d.getFullYear();

                        what_to_render.current_date = m_names[curr_month] + " " + curr_date + ", " + curr_year;

                        $('.mktoFakeForm input[name="Company"]').on('change', function (e) {
                            if ($('.mktoFakeForm input[name="cPFCompanyLegalName"]').val().length == 0) {
                                what_to_render.company_name = $(this).val();
                                custom_data.company_name = $(this).val();
                            } else {
                                what_to_render.company_name = $('.mktoFakeForm input[name="cPFCompanyLegalName"]').val();
                                custom_data.company_name = $('.mktoFakeForm input[name="cPFCompanyLegalName"]').val();
                            }
                        });

                        $('.mktoFakeForm input[name="cPFCompanyLegalName"]').on('change', function (e) {
                            what_to_render.company_name = $(this).val();
                            custom_data.company_name = $(this).val();
                        });

                        $('.mktoFakeForm select[name="Country"]').on('change', function (e) {
                            what_to_render.country = $(this).val();
                            custom_data.country = $(this).val();
                        });


                        // Functions for GroupPay form only:
                        if (agreement_key == 'grouppay-addon-us') {
                            $('#mktoForm_1456 select#gpf_ContractVersion option').eq(1).prop('selected', true);
                        } else {
                            $('#mktoForm_1456 select#gpf_ContractVersion option').eq(2).prop('selected', true);
                        }

                    }


                    // If Marketo FakeForm exists:
                    if ($('.mktoFakeForm').length) {

                        mktoFakeInit(form, form_id);

                        var forms = MktoForms2.allForms();

                        $.each(forms, function (index, form) {

                            form.onSuccess(function (values, followUpUrl) {


                                // Enable NativeMarketo submit button for reusable submit:
                                $(form.getFormElem).find('button[type=submit]').removeAttr('disabled');

                                // GoogleAnalytics Custom Submitions:
                                if (form_id == '1289') {
                                    ga('send', 'event', 'Form Submission', 'Online Enrollment | Hotel', 'CommPay | /enroll/commpay/');
                                }
                                if (form_id == '1121') {
                                    ga('send', 'event', 'Form Submission', 'Contact Us | Generic', 'Get Started | ' + window.location.pathname);
                                }

                                if (!$('.mktoFakeForm').hasClass("followUpUrl")) {
                                    return false;
                                }

                            });

                        });


                        // Keydown navigations:
                        $('.mktoFakeForm input:not([type="button"])').keydown(function (e) {
                            if (e.keyCode == 13) {
                                e.preventDefault();
                                $(this).closest('.owl-item.active .page').find('.mktoButton').click();
                                return false;
                            }
                        });


                        // Open select2 on focus:
                        $(document).on('focus', '.select2', function (e) {
                            if (e.originalEvent) {
                                $(this).siblings('select').select2('open');
                            }
                        });


                        function mktoFakeInit(form, form_id) {

                            // Init select2 dropdowns for Marketo FakeForm:
                            $('select.selectpicker:not(no-search)').select2({
                                matcher: matchStart
                            });
                            $('select.selectpicker.no-search').select2({
                                minimumResultsForSearch: Infinity
                            });


                            // Сreate labels instead of placeholders:
                            $('.section-form-type-1,.section-contacts-page').find('input, textarea').each(function () {
                                if ($(this).attr('placeholder')) {
                                    $(this).parent().prepend($("<label>" + $(this).attr('placeholder') + "</label>"));
                                    $(this).removeAttr('placeholder');
                                }
                            });


                            // Init owlCarousel slider for Marketo FakeForm steps:
                            var _hidden = $(form.getFormElem());
                            var _this = $('.section-form[data-hidden-form-id=' + _hidden.attr('id') + ']');

                            var stepForm = _this.find('.mktoFakeForm .pages').addClass('owl-carousel').owlCarousel({
                                animateIn: 'fadeIn',
                                animateOut: 'fadeOut',
                                autoHeight: false,
                                autoHeightClass: 'owl-height',
                                items: 1,
                                mouseDrag: false,
                                touchDrag: false,
                                nav: false,
                                dots: false,
                                lazyLoad: false,
                                activeClass: 'active'
                            });

                            // Event on changed step:
                            stepForm.on('changed.owl.carousel', function (e) {

                                var carousel = $(e.currentTarget);
                                var step = e.item.index;

                                //console.log(step);

                                // Change form step nav
                                carousel.parent().find('.form-steps:not(.static)').each(function () {
                                    $(this).find('.step').each(function (index, step_item) {
                                        if (index < step) {
                                            $(step_item).addClass('done');
                                        } else if (index > step) {
                                            $(step_item).addClass('passive');
                                        } else {
                                            $(step_item).removeClass('passive');
                                        }

                                    });

                                });


                                // Focus on first field
                                var focus_objs = _this.find(".owl-item").eq(step).find('input, textarea, select'),
                                    first_obj = focus_objs.first();

                                // Open select2 if it is first elem:
                                setTimeout(function () {
                                    if (first_obj.prop('tagName') === "SELECT") {
                                        if ($(window).width() > 1024) {
                                            first_obj.select2('open');
                                        }
                                    } else {
                                        first_obj.focus();
                                    }

                                    first_obj.focus();
                                }, 500);


                                // Functions for CommPay && SurePay form only:
                                if (form_id == '1289' && step == 4 || form_id == '1147' && step == 3 || form_id == '1456' && step == 1 || form_id == '1477' && step == 3) {

                                    //console.log('Load PactSafe');

                                    _ps('load', agreement_key, {
                                        container_selector: 'pactsafe_checkbox-' + agreement_key,
                                        render_data: what_to_render,
                                        custom_data: custom_data,
                                        signer_id_selector: "Email"
                                    });

                                    _ps('load', agreement_key2, {
                                        container_selector: 'pactsafe_checkbox-' + agreement_key2,
                                        render_data: what_to_render,
                                        custom_data: custom_data,
                                        signer_id_selector: "Email"
                                    });


                                    // WHEN ALL CONTRACTS HAVE BEEN CHECKED/ACCEPTED, DO SOMETHING
                                    _ps.on('valid', function (e) {
                                        // Ckeck checkbox cPFTermsofServiceAgreement in Native Marketo:
                                        _hidden.find('input[name="cPFTermsofServiceAgreement"],input[name="sPFTermsofServiceAgreement"],input[name="gpf_TermsofServiceAgreement"],input[name="rPTermsofServiceAgreement"]').attr('checked', true).prop('checked', true);
                                        // Update CustomData:
                                        //_ps('send', 'updated', {custom_data: custom_data});
                                    });
                                    _ps.on('invalid', function () {
                                        _hidden.find('input[name="cPFTermsofServiceAgreement"],input[name="sPFTermsofServiceAgreement"],input[name="gpf_TermsofServiceAgreement"],input[name="rPTermsofServiceAgreement"]').attr('checked', false).prop('checked', false);
                                        // _ps(agreement_key + ':send', 'disagreed');
                                    });

                                }


                            });


                            $('.mktoFakeForm .invalid').on('change keyup paste', function (e) {
                                validateMktoPage($(this).closest('.page'));
                            });


                            // Synchronous filling of form fields:
                            _this.find('input[type="text"], input[type="tel"], input[type="email"], textarea').each(function () {
                                $(this).attr('autocomplete', 'false');

                                $(this).on('change keyup paste', function (e) {
                                    _hidden.find('#' + $(this).attr('name')).val($(this).val());
                                });
                            });


                            _this.find('input[type="radio"]').on('change', function (e) {
                                //_hidden.find('input[type="radio"][id="'+$(this).attr('name')+'"]').trigger('click');
                                _hidden.find('input[type="radio"][name="' + $(this).attr('name') + '"][id$="' + $(this).attr('id').substr(-2) + '"]').trigger('click');
                            });


                            _this.find('input[type="checkbox"]').on('change', function (e) {

                                var name = $(this).attr('name');
                                _hidden.find('#' + name).trigger('click');


                                // Switcheble checkbox:
                                if ($(this).parent().attr('data-switchable') === "true") {

                                    var section = $(this).parent().attr('data-switch');

                                    if (this.checked) {
                                        if ($(this).parent().attr('data-switch-reverse')) {
                                            $('.' + section).slideUp(function () {
                                                clearSubSection('.' + section);
                                            });
                                        } else {
                                            $('.' + section).slideDown();
                                        }
                                    } else {
                                        if ($(this).parent().attr('data-switch-reverse')) {
                                            $('.' + section).slideDown();
                                        } else {
                                            $('.' + section).slideUp(function () {
                                                clearSubSection('.' + section);
                                            });
                                        }
                                    }
                                }
                            });

                            function clearSubSection(section) {


                                $(section).find('.invalid').removeClass('invalid');
                                $(section).find('.mktoError').remove();

                                $(section).find('input, select, textarea').each(function () {

                                    if ($(this).prop('tagName') === "INPUT" || $(this).prop('tagName') === "TEXTAREA") {
                                        $(this).val('');
                                        $(this).prop('checked', false);
                                        _hidden.find('#' + $(this).attr('name')).val('').prop('checked', false);
                                    }

                                    if ($(this).prop('tagName') === "SELECT") {
                                        $(this).find('option').eq(0).prop('selected', true).trigger('change');
                                        _hidden.find('#' + $(this).attr('name')).find('option').eq(0).prop('selected', true).trigger('change');
                                        //$(this).next('.select2').find('.select2-selection__rendered').text($(this).val());
                                    }

                                });
                            }

                            _this.find('select').on('change', function (e) {
                                _hidden.find('select#' + $(this).attr('name')).val($(this).val()).change();
                            });


                            // Checkboxes group on 2th step of CommPay form:
                            $('.GroupListPending input').on('change', function (e) {
                                //
                                console.log(_hidden.find('#' + $(this).attr('id')));
                                if ($(this).attr('id') === 'mktoCheckbox_8940_54') {
                                    if ($(this).is(':checked')) {
                                        $('.GroupListPending').find('input:not(#mktoCheckbox_8940_54)').each(function () {
                                            $(this).attr('checked', false).prop('checked', false);
                                            _hidden.find('#' + $(this).attr('id')).attr('checked', false).prop('checked', false);
                                        })
                                        _hidden.find('#' + $(this).attr('id')).attr('checked', true).prop('checked', true);
                                    } else {
                                        $(this).attr('checked', true).prop('checked', true);
                                    }
                                } else {
                                    _hidden.find('#mktoCheckbox_8940_54').attr('checked', false).prop('checked', false);
                                    if ($('.GroupListPending').find('input:not(#mktoCheckbox_8940_54):checked').length >= 1) {
                                        $('input#mktoCheckbox_8940_54').attr('checked', false).prop('checked', false);
                                    } else {
                                        $('input#mktoCheckbox_8940_54').attr('checked', true).prop('checked', true);
                                    }
                                    _hidden.find('#' + $(this).attr('id')).click();
                                }
                                //
                            });

                            $('.HotelBrandAffiliation input[type="checkbox"]').on('change', function (e) {
                                //
                                if ($(this).attr('id') === 'mktoCheckbox_8939_6') {
                                    if ($(this).is(':checked')) {
                                        $('.HotelBrandAffiliation').find('input:not(#mktoCheckbox_8939_6)').each(function () {
                                            $(this).attr('checked', false).prop('checked', false);
                                            _hidden.find('#' + $(this).attr('id')).attr('checked', false).prop('checked', false);
                                        })
                                        _hidden.find('#' + $(this).attr('id')).attr('checked', true).prop('checked', true);
                                    } else {
                                        $(this).attr('checked', true).prop('checked', true);
                                    }
                                } else {
                                    _hidden.find('#mktoCheckbox_8939_6').attr('checked', false).prop('checked', false);
                                    $('.HotelBrandAffiliation input[type="checkbox"]').not(this).prop('checked', false);
                                    $('.HotelBrandAffiliation').find('input:not(#mktoCheckbox_8939_6)').each(function () {
                                        _hidden.find('#' + $(this).attr('id')).attr('checked', false).prop('checked', false);
                                    })
                                    if ($('.HotelBrandAffiliation').find('input:not(#mktoCheckbox_8939_6):checked').length >= 1) {
                                        $('input#mktoCheckbox_8939_6').attr('checked', false).prop('checked', false);
                                    } else {
                                        $('input#mktoCheckbox_8939_6').attr('checked', true).prop('checked', true);
                                    }
                                    _hidden.find('#' + $(this).attr('id')).click();

                                }
                                if ($('.HotelBrandAffiliation').find('#mktoCheckbox_8939_6').is(':checked')) {
                                    $('.HotelBrandAffiliation').find('input:not(#mktoCheckbox_8939_6)').each(function () {
                                        _hidden.find('#' + $(this).attr('id')).attr('checked', false).prop('checked', false);
                                    })
                                }
                                //
                            });

                            // Checkboxes group on 3th step of SurePay form:
                            $('.WhichGDSdoyouuse input[type="checkbox"]').on('change', function (e) {
                                if ($(this).attr('id') === 'GDS_None') {
                                    if ($(this).is(':checked')) {
                                        $('.WhichGDSdoyouuse').find('input:not(#GDS_None)').each(function () {
                                            $(this).attr('checked', false).prop('checked', false);
                                        })
                                    } else {
                                        $(this).attr('checked', true).prop('checked', true);
                                    }
                                } else {
                                    if ($('.WhichGDSdoyouuse').find('input:not(#GDS_None):checked').length >= 1) {
                                        $('.WhichGDSdoyouuse input#GDS_None').attr('checked', false).prop('checked', false);
                                    } else {
                                        $('.WhichGDSdoyouuse input#GDS_None').attr('checked', true).prop('checked', true);
                                    }
                                }
                            });


                            // Click on mktoButton:
                            _this.find('input.mktoButton').on('click', function (e) {
                                e.preventDefault();


                                // prevPage:
                                if ($(this).hasClass('prevPage')) {
                                    stepForm.trigger('prev.owl.carousel');
                                    $("html, body").animate({
                                        scrollTop: (($('.section-form').offset().top) - 186)
                                    }, 1000);

                                } else {

                                    var curr_page = $(this).closest('.page');


                                    // If validate:
                                    if (validateMktoPage(curr_page)) {


                                        // Functions for SurePay, RecoverPro and CommPay forms:
                                        if (form_id == '1289' || form_id == '1477' || form_id == '1147') {
                                            var completed_step = $(this).closest('.owl-item').index() + 1;
                                            if (form_id == '1477') {
                                                if (compleateStepForm1477 == false) {
                                                    _hidden.find('#spf_FormStepStatus option, #cpf_FormStepStatus option, #rFFormStepStatus option').eq(completed_step).prop('selected', true);

                                                } else {
                                                    _hidden.find('#spf_FormStepStatus option, #cpf_FormStepStatus option, #rFFormStepStatus option').eq(compleateStepForm1477).prop('selected', true);

                                                }
                                            } else if (form_id == '1147') {
                                                if (compleateStepForm1147 == false) {
                                                    _hidden.find('#spf_FormStepStatus option, #cpf_FormStepStatus option, #rFFormStepStatus option').eq(completed_step).prop('selected', true);

                                                } else {
                                                    _hidden.find('#spf_FormStepStatus option, #cpf_FormStepStatus option, #rFFormStepStatus option').eq(compleateStepForm1147).prop('selected', true);

                                                }
                                            } else {
                                                _hidden.find('#spf_FormStepStatus option, #cpf_FormStepStatus option, #rFFormStepStatus option').eq(completed_step).prop('selected', true);

                                            }
                                        }

                                        // NativeMarketo Submit:
                                        _hidden.find('button[type=submit]').trigger('click');
                                        //console.log('validateMktoPage');


                                        // Functions for CommPay form only:
                                        if (form_id == '1289') {

                                            // Choose the way, when checked desired checkbox:
                                            if (curr_page.find('.GroupListPending').length) {
                                                if (curr_page.find('#mktoCheckbox_8940_54').prop('checked') == true && curr_page.find('#mktoCheckbox_8939_6').prop('checked') == true) {
                                                } else {
                                                    $(this).attr('data-path', curr_page.find('.GroupListPending').data('path') - 1);

                                                    var fd = _hidden.serializeArray();
                                                    fd.push({name: 'formVid', value: '1289'});
                                                    $.ajax({
                                                        type: "POST",
                                                        url: "https://app-ab26.marketo.com/index.php/leadCapture/save2",
                                                        data: fd,
                                                        success: function (resp) {
                                                            console.log(resp);
                                                        }
                                                    });
                                                }
                                            }

                                        }


                                        // Navigate to next step:
                                        if ($(this).hasClass('nextPage')) {
                                            if ($(this).attr('data-path')) {
                                                var path = $(this).attr('data-path');
                                                stepForm.trigger('to.owl.carousel', [path, 1, true]);
                                            } else {
                                                stepForm.trigger('next.owl.carousel');
                                            }

                                        }

                                        // Submission actions:
                                        if ($(this).attr('type') === 'submit') {

                                            // Functions for CommPay form only:
                                            if (form_id == '1289') {

                                                data_needs_saving = 'false';

                                                /*if (_ps.getByKey(agreement_key).allChecked()) {
                                                 $('#pactsafe_checkbox-' + agreement_key).removeClass('invalid');
                                                 } else {
                                                 $('#pactsafe_checkbox-' + agreement_key).addClass('invalid');
                                                 }*/

                                                if ($(this).attr('data-path') === '7') {

                                                    if (_ps.getByKey(agreement_key).allChecked()) {
                                                        pdf_generator();
                                                        var path = $(this).attr('data-path');
                                                        stepForm.trigger('to.owl.carousel', [path, 1, true]);
                                                        $('#pactsafe_checkbox-' + agreement_key).removeClass('invalid');
                                                        $('h2.section-title,.section-subtitle').hide();


                                                        //_ps('send', 'updated', {custom_data: custom_data});

                                                        //_ps('set', 'signer_id', signer_id);
                                                        //_ps('commpay-online:retrieveHTML', what_to_render);
                                                        //_ps("set", "custom_data", custom_data);
                                                        _ps(agreement_key + ':send', 'agreed', {
                                                            disable_sending: false,
                                                            custom_data: custom_data,
                                                            //signer_id_selector: "Email",
                                                            render_data: what_to_render
                                                        });


                                                    }
                                                    /* else {
                                                     $('#pactsafe_checkbox-' + agreement_key).addClass('invalid');
                                                     alert("You must agree to the terms to continue.");
                                                     }*/

                                                } else {
                                                    stepForm.trigger('next.owl.carousel');
                                                    $('h2.section-title,.section-subtitle').hide();
                                                }
                                            }  // Functions for SurePay form only:
                                            else if (form_id == '1147') {

                                                data_needs_saving = 'false';


                                                /*if (_ps.getByKey(agreement_key).allChecked()) {
                                                 $('#pactsafe_checkbox-' + agreement_key).removeClass('invalid');
                                                 } else {
                                                 $('#pactsafe_checkbox-' + agreement_key).addClass('invalid');
                                                 }

                                                 if (_ps.getByKey(agreement_key2).allChecked()) {
                                                 $('#pactsafe_checkbox-' + agreement_key2).removeClass('invalid');
                                                 } else {
                                                 $('#pactsafe_checkbox-' + agreement_key2).addClass('invalid');
                                                 }*/


                                                if (_ps.getByKey(agreement_key).allChecked()/* && _ps.getByKey(agreement_key2).allChecked()*/) {

                                                    //_hidden.find('input[name="cPFTermsofServiceAgreement"],input[name="sPFTermsofServiceAgreement"]').attr('checked', true).prop('checked', true);
                                                    pdf_generator();
                                                    stepForm.trigger('next.owl.carousel');

                                                    $('h2.section-title,.section-subtitle').hide();

                                                    setTimeout(function () {
                                                        _ps(agreement_key + ':send', 'agreed', {
                                                            disable_sending: false,
                                                            custom_data: custom_data,
                                                            render_data: what_to_render
                                                        });
                                                    }, 1000);

                                                    /*setTimeout(function () {
                                                     _ps(agreement_key2 + ':send', 'agreed', {
                                                     disable_sending: false,
                                                     custom_data: custom_data,
                                                     render_data: what_to_render
                                                     });
                                                     }, 2000);*/


                                                }
                                                /* else {
                                                 alert("You must agree to the terms to continue.");
                                                 }*/
                                            } else if (form_id == '1477') {

                                                data_needs_saving = 'false';


                                                /*if (_ps.getByKey(agreement_key).allChecked()) {
                                                 $('#pactsafe_checkbox-' + agreement_key).removeClass('invalid');
                                                 } else {
                                                 $('#pactsafe_checkbox-' + agreement_key).addClass('invalid');
                                                 }

                                                 if (_ps.getByKey(agreement_key2).allChecked()) {
                                                 $('#pactsafe_checkbox-' + agreement_key2).removeClass('invalid');
                                                 } else {
                                                 $('#pactsafe_checkbox-' + agreement_key2).addClass('invalid');
                                                 }*/


                                                if (_ps.getByKey(agreement_key).allChecked() && _ps.getByKey(agreement_key2).allChecked()) {

                                                    //_hidden.find('input[name="cPFTermsofServiceAgreement"],input[name="sPFTermsofServiceAgreement"]').attr('checked', true).prop('checked', true);
                                                    pdf_generator();
                                                    stepForm.trigger('next.owl.carousel');

                                                    $('h2.section-title,.section-subtitle').hide();

                                                    setTimeout(function () {
                                                        _ps(agreement_key + ':send', 'agreed', {
                                                            disable_sending: false,
                                                            custom_data: custom_data,
                                                            render_data: what_to_render
                                                        });
                                                    }, 1000);

                                                    setTimeout(function () {
                                                        _ps(agreement_key2 + ':send', 'agreed', {
                                                            disable_sending: false,
                                                            custom_data: custom_data,
                                                            render_data: what_to_render
                                                        });
                                                    }, 2000);


                                                }
                                                /* else {
                                                 alert("You must agree to the terms to continue.");
                                                 }*/
                                            } else if (form_id == '1456') {
                                                // Functions for GroupPay form only:
                                                data_needs_saving = 'false';

                                                if (_ps.getByKey(agreement_key).allChecked()) {

                                                    $('#pactsafe_checkbox-' + agreement_key).removeClass('invalid');
                                                    stepForm.trigger('next.owl.carousel');
                                                    $('h2.section-title,.section-subtitle').hide();

                                                    pdf_generator();

                                                    _ps(agreement_key + ':send', 'agreed', {
                                                        disable_sending: false,
                                                        custom_data: custom_data,
                                                        render_data: what_to_render
                                                    });

                                                }
                                                /* else {
                                                 $('#pactsafe_checkbox-' + agreement_key).addClass('invalid');
                                                 alert("You must agree to the terms to continue.");
                                                 }*/

                                            } else {
                                                stepForm.trigger('next.owl.carousel');
                                                $('h2.section-title,.section-subtitle').hide();
                                            }


                                        }


                                        // Scroll to section top:
                                        $("html, body").animate({
                                            scrollTop: (($('.section-form').offset().top) - 186)
                                        }, 1000);


                                    } else {
                                        var offset = $('.invalid:visible').first().offset();

                                        if (typeof offset != 'undefined') {
                                            var dest = offset.top - 100;
                                        } else {
                                            var dest = ($('.section-form').offset().top) - 186;
                                        }

                                        $("html, body").animate({
                                            scrollTop: dest
                                        }, 1000);
                                    }

                                }

                                e.stopPropagation();

                            });


                        }

                        function validationError(field, message) {
                            message = message || "This field is required.";
                            $(field).parent('.bootstrap-select').addClass('invalid');
                            $(field).addClass('invalid').parent().append('<div class="mktoError"><div class="mktoErrorArrowWrap"><div class="mktoErrorArrow"></div></div><div class="mktoErrorMsg">' + message + '</div></div>');
                        }

                        function validateMktoPage(page) {

                            var haveErrors = false;

                            if (!page.find('.switchable_section:hidden').length) {

                                page.find('input, select, textarea').each(function () {


                                    $(this).parent().find('.mktoError').remove();
                                    $(this).parent().find('.invalid').removeClass('invalid');
                                    $(this).parent('.bootstrap-select').removeClass('invalid');

                                    if ($(this).attr('type') !== 'submit') {

                                        if ($(this).attr('data-required') === "true") {

                                            if ($(this).attr('type') === 'email') {
                                                var value = $(this).val();
                                                if (value.length !== 0) {
                                                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                                    if (!re.test(String(value).toLowerCase())) {
                                                        haveErrors = true;
                                                        validationError($(this), 'Must be valid email.<br>example@yourdomain.com');
                                                    }
                                                } else {
                                                    haveErrors = true;
                                                    validationError($(this));
                                                }
                                            }

                                            if ($(this).attr('type') === 'text' || $(this).prop('tagName') === 'TEXTAREA') {

                                                var value = $(this).val();

                                                if (value.length === 0) {
                                                    haveErrors = true;
                                                    validationError($(this));
                                                }

                                            }

                                            if ($(this).attr('type') === "tel") {
                                                var value = $(this).val();
                                                if (value.length !== 0) {
                                                    //var re = /^\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})$/;
                                                    var re = /^[ ()+0-9-]+$/;
                                                    if (!re.test(String(value).toLowerCase())) {
                                                        haveErrors = true;
                                                        validationError($(this), 'Must be a phone number');
                                                    }
                                                } else {
                                                    haveErrors = true;
                                                    validationError($(this));
                                                }
                                            }


                                            if ($(this).attr('type') === 'radio') {
                                                var radioName = $(this).attr('name');
                                                if ($('input[name=' + radioName + ']:checked').length) {
                                                    // good
                                                } else {
                                                    haveErrors = true;
                                                    validationError($(this));
                                                }
                                            }

                                            if ($(this).attr('type') === 'checkbox' && $(this).attr('data-switchable') !== "true") {
                                                if ($(this)[0].checked === false) {
                                                    haveErrors = true;
                                                    validationError($(this));
                                                }
                                            }

                                            if ($(this).prop('tagName') === "SELECT") {
                                                var value = $(this).val();
                                                if (value === "") {
                                                    haveErrors = true;
                                                    validationError($(this));
                                                }
                                            }

                                        } else if ($(this).attr('data-required') === "false") {

                                            if ($(this).attr('type') === "tel") {
                                                var value = $(this).val();
                                                if (value.length !== 0) {
                                                    var re = /^[ ()+0-9-]+$/;
                                                    if (!re.test(String(value).toLowerCase())) {
                                                        haveErrors = true;
                                                        validationError($(this), 'Must be a phone number');
                                                    }
                                                }
                                            }

                                            if ($(this).attr('type') === "email") {
                                                var value = $(this).val();
                                                if (value.length !== 0) {
                                                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                                    if (!re.test(String(value).toLowerCase())) {
                                                        haveErrors = true;
                                                        validationError($(this), 'Must be valid email.<br>example@yourdomain.com');
                                                    }
                                                }
                                            }

                                        }
                                    }

                                });
                            }
                            //reCaptha



                            if (page.find('[id^=pactsafe_checkbox-]').length) {
                                if (typeof agreement_key != 'undefined') {
                                    if (_ps.getByKey(agreement_key).allChecked()) {
                                        $('#pactsafe_checkbox-' + agreement_key).removeClass('invalid');
                                    } else {
                                        //alert("You must agree to the " + agreement_key + " terms to continue.");
                                        alert("Please agree to the terms to continue.");
                                        $('#pactsafe_checkbox-' + agreement_key).addClass('invalid');
                                        haveErrors = true;
                                    }
                                }
                                if (typeof agreement_key2 != 'undefined') {
                                    if (_ps.getByKey(agreement_key2).allChecked()) {
                                        $('#pactsafe_checkbox-' + agreement_key2).removeClass('invalid');
                                    } else {
                                        //alert("You must agree to the " + agreement_key2 + " terms to continue.");
                                        alert("Please agree to the terms to continue.");
                                        $('#pactsafe_checkbox-' + agreement_key2).addClass('invalid');
                                        haveErrors = true;
                                    }
                                }
                            }


                            if (haveErrors) {
                                return false;
                            }

                            return true;

                        }

                    }


                });


            }

        }
    );

    $(window).on('resize', function () {
        setTimeout(function () {
            $(window).scroll();
        }, 500);
    });

    $.fn.serializeObject = function () {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    function pdf_generator() {
        $('.button.download-pdf').css('display', 'inline-block');
        var data = $('form.mktoForm').serializeObject(),
            ajaxurl = oc_variables.ajax_url;
        //console.log(data);

        $.ajax({
            url: ajaxurl,
            type: "post",
            data: {
                action: 'pdf_generator',
                data: data
            },
            beforeSend: function () {
                $('.download-pdf').css('opacity', '.5').text('PROCESSING...');
            },
            error: function (data) {
                alert("error!");
            },
            success: function (data) {

                var response = JSON.parse(data);

                console.log(response);

                $('.download-pdf').addClass('ready').attr('href', response.filePath).css('opacity', '1').text('View/Print Order Form');

                /*JS_UploadDropbox(response.filePath, response.fileName);*/
            }

        });
    }


    /*
     function JS_UploadDropbox(url, name) {
     // Instantiate the client proxy
     // You may need to adjust the path to reflect the URI of your server proxy
     var temboo = new TembooProxy('/wp-content/themes/onyx/TembooProjects/JS_UploadDropbox/proxy-server.php');

     // Add the upload Choreo
     var uploadChoreo = temboo.addChoreo('jsUpload');

     // Add inputs
     uploadChoreo.setInput('Path', name);
     uploadChoreo.setInput('FileURL', window.location.origin + url);

     // Success callback
     var showResult = function (outputs, outputFilters) {
     // Display outputs
     if (outputFilters) {
     // Display named output filters
     for (var name in outputFilters) {
     console.log(name + ':');
     for (var item in outputs[name]) {
     console.log('    ' + outputs[name][item]);
     }
     }
     } else {
     // Display raw outputs
     for (var name in outputs) {
     console.log(name + ': ' + outputs[name]);
     }
     }
     };

     // Error callback
     var showError = function (error) {
     if (error.type === 'DisallowedInput') {
     console.log(error.type + ' error: ' + error.inputName);
     } else {
     console.log(error.type + ' error: ' + error.message);
     }
     };

     // Run the Choreo, specifying success and error callback handlers
     uploadChoreo.execute(showResult, showError);
     }
     */

})(jQuery);

// MARKETO FORMS (removing inline STYLE attributes and disabling STYLE and LINK elements)
function destyleMktoForm(mktoForm, moreStyles) {
    var formEl = mktoForm.getFormElem()[0],
        arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

    // remove element styles from <form> and children
    var styledEls = arrayFrom(formEl.querySelectorAll("[style]")).concat(formEl);
    styledEls.forEach(function (el) {
        el.removeAttribute("style");
    });

    // disable remote stylesheets and local <style>s
    var styleSheets = arrayFrom(document.styleSheets);
    styleSheets.forEach(function (ss) {
        if ([mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || formEl.contains(ss.ownerNode)) {
            ss.disabled = true;
        }
    });

    if (!moreStyles) {
        formEl.setAttribute("data-styles-ready", "true");
    }
};


// WEBPACK FOOTER //
// ./src/js/custom/marketo-forms.js